import React, { useState } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormSwitch,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilPencil, cilTrash } from '@coreui/icons'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import FixtureService from 'src/service/FixtureService'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'

const Table = ({
  columns,
  users,
  displayDetails,
  setDisplayDetails,
  activePage,
  setActivePage,
  columnFilter,
  setColumnFilter,
  columnSorter,
  setColumnSorter,
  itemsPerPage,
  setItemsPerPage,
  fetchData,
  setLoading,
  loading,
  onEditFixture,
}) => {
  const deleteFixture = (id) => {
    FixtureService.deleteFixture({ id }).then((res) => {
      if (res.status === 200) {
        setLoading(false)
        fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
        ToastComponent(res.message, 'success')
      }
    })
  }

  const handleChangeStatus = (itemId) => {
    const position = displayDetails.indexOf(itemId)
    let newDetails = displayDetails.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...displayDetails, itemId]
    }
    setDisplayDetails(newDetails)

    FixtureService.changeDisplayStatus({ fixtureId: itemId }).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteFixture(tableId)
    return setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    const data = { id, type: 'fixture' }
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          id: (item) => (
            <td>
              <span
                className="fw-semibold text-primary"
                role="button"
                onClick={() => onEditFixture(item.id)}
              >
                {item.id}
              </span>
            </td>
          ),
          round: (item) => <td>{item.round ?? '-'}</td>,
          status: (item) => (
            <td>
              {item.status === 0 && <CBadge color={'warning'}>Not Started</CBadge>}
              {item.status === 1 && <CBadge color={'danger'}>In-Progress</CBadge>}
              {item.status === 2 && <CBadge color={'success'}>Completed</CBadge>}
            </td>
          ),
          grade: (item) => <td>{item.grade ?? ''}</td>,
          start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
          start_time: (item) => <td> {moment(item.start_time, ['HH:mm']).format('h:mm A')} </td>,
          display: (item) => (
            <td className="py-2">
              <CFormSwitch
                label=""
                id={`display_id${item.id}`}
                name={`display_name${item.id}`}
                value={item.id}
                checked={!displayDetails.includes(item.id)}
                onChange={() => handleChangeStatus(item.id)}
              />
            </td>
          ),
          actions: (item) => (
            <td className="py-2">
              <CDropdown alignment="end">
                <CDropdownToggle color="transparent" caret={false} className="p-0">
                  <CIcon icon={cilOptions} role="button" />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem role="button" onClick={() => onEditFixture(item.id)}>
                    <CIcon icon={cilPencil} className="me-2" />
                    Edit
                  </CDropdownItem>
                  <CDropdownItem
                    role="button"
                    className="text-danger"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    <CIcon icon={cilTrash} className="me-2" />
                    Delete
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
          className: 'align-middle mb-0',
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </div>
  )
}

export default Table
